export type DateType = Date | null;

export interface Dictionary<T> {
  [Key: string]: T;
}

export class HttpError extends Error {
  constructor(public code: string, public message: string) {
    super(message);
    this.name = code;
  }
}
